import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, catchError, concatMap, first, forkJoin, map, of } from 'rxjs';

import { SastreButtonApiRepository } from '../infrastructure/sastre-button.api.repository';

import { SastreRecommendation } from './sastre-button.model';
import { SastreButtonTransformer } from './sastre-button.transformer';

import { CorePlatformService } from '@core/infrastructure/platform/platform.service';
import { getLanguageLocale, getStoreId } from '@core/infrastructure/state/core.selectors';
import { CoreStorageService } from '@core/infrastructure/storage/storage.service';
import { SastreService } from '@features/products/sastre/sastre.service';
import { selectUserIsLogged } from '@shared/user/store';

@Injectable()
export class SastreButtonService {
    constructor(
        private readonly repository: SastreButtonApiRepository,
        private readonly storageService: CoreStorageService,
        private readonly store: Store,
        private readonly platformService: CorePlatformService,
    ) {}

    private readonly params$ = forkJoin([
        this.store.select(getStoreId).pipe(first()),
        this.store.select(getLanguageLocale).pipe(first()),
        this.store.select(selectUserIsLogged).pipe(map((isLoggedIn) => !isLoggedIn), first()),
    ]);

    // ERROR RuntimeError: NG0205 Google analytics ID not found TypeError: Cannot read properties of undefined (reading 'split')
    public isActivated(productId: string): Observable<boolean> {
        if (this.platformService.isBrowser()) {
            return this.params$.pipe(
                concatMap(([storeId, locale, isVisitor]) => {
                    if (!isVisitor || SastreService.getVisitorId(this.storageService)) {
                        return this.repository.sizingInfo(storeId, productId, locale, isVisitor).pipe(
                            map((data) => SastreButtonTransformer.IsActivated(data))
                        );
                    }
                    return of(false);
                }),
                catchError(() => of(false)),
            );
        }
        return of(false);
    }

    public recommendation(productId: string): Observable<SastreRecommendation> {
        return this.params$.pipe(
            concatMap(([storeId, locale, isVisitor]) =>
                this.repository.recommendation(storeId, productId, locale, isVisitor)),
            map((data) => SastreButtonTransformer.Recommendation(data)),
        );
    }
}
